/**
*
* PreFooter
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from '../../style/mediainjector';

import {
  Section,
  Container,
  Div,
  ContainerFlex,
  Divider,
  FlexBox,
} from '../Blocks';

import pearson from './images/Pearson_logo.svg';
import liftt from './images/LIFTT-logo.png';
import onefactory from './images/logo-one-factory.svg';

const H2 = styled.h2`
  text-align: center;
  margin: 5.2rem auto;
  &:first-child {
    margin-top: 0;
  }
  ${media.lt667`
    padding: 0 2rem;
    margin: 5.2rem auto 3.2rem;
  `}
`;

export const NumberGrid = styled(Div)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 60px;
  ${media.lt667`
    gap: 30px;
  `}
`;

export const NumberBlock = styled(Div)`
  width: 180px;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  flex-shrink: 0;
  &:first-child{
    margin-left: 0;
  }
  &:last-child{
    margin-right: 0;
  }
  span {
    display: block;
    margin: 1.6rem 0 0;
  }
`;

export const Number = styled(Div)`
  width: 120px;
  font-size: 3.2rem;
  font-weight: 700;
  background-color: $white;
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,0.1);
  box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.1);
`;

export const PartnersRow = styled(ContainerFlex)`
  position: relative;
  align-items: flex-start;
  ${media.lt667`
    flex-direction: column-reverse;
  `}
`;

export const PartnersBlock = styled(FlexBox)`
  position: relative;
  align-items: center;
  text-align: center;
  flex-grow: 1;
  flex-wrap: wrap;
  h2 {
    min-width: 100%;
    margin-top: 0;
  }
  img {
    display: block;
    max-width: 220px;
    padding: 0 10px;
  }
  ${media.lt667`
    width: 100%;
    flex-direction: column;
    img {
      margin-bottom: 6rem;
      &:nth-child(3) {
        margin-bottom: 0;
      }
    }
  `}
`;
class PreFooter extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const { partnership } = this.props;
    return (
      <>
        <Section
          padding="0"
          paddingmobile="0"
          direction="column"
        >
          <Container>
            <H2>I nostri numeri</H2>
            <NumberGrid>
              <NumberBlock>
                <Number>
                  30k
                </Number>
                <span>
                  <strong>Studenti attivi</strong><br />Con assistenza<br />dedicata 7/7
                </span>
              </NumberBlock>
              <NumberBlock>
                <Number>
                  5M
                </Number>
                <span>
                  <strong>Esercizi erogati</strong><br />ogni mese sulle<br />nostre piattaforme
                </span>
              </NumberBlock>
              <NumberBlock>
                <Number>
                  +30%
                </Number>
                <span>
                  <strong>Miglioramento</strong><br />dei voti in un<br />semestre di utilizzo
                </span>
              </NumberBlock>
            </NumberGrid>
          </Container>
        </Section>
        <Divider />
        <Section
          padding="0 0 80px"
          paddingmobile="0 0 40px"
          direction="column"
        >
          <PartnersRow>
            <PartnersBlock>
              <h2>Ci sostengono</h2>
              <img src={liftt} alt="LIFTT" width="188" height="80px" />
              <img src={onefactory} alt="One factory" width="200" height="80px" />
            </PartnersBlock>
            {partnership && (
              <PartnersBlock>
                <h2>In partnership con</h2>
                <img src={pearson} alt="Pearson" width="200" height="80px" />
              </PartnersBlock>
            )}
          </PartnersRow>
        </Section>
      </>
    );
  }
}

PreFooter.propTypes = {
  partnership: PropTypes.bool,
};

export default PreFooter;
